import { pathLanguageCode } from '../constants/constants';

export const routes = {
  login_path: `remuneraciones/${pathLanguageCode}/login`,
  login_path_consultant: `remuneraciones/${pathLanguageCode}/consultor/login`,
  login_path_inspector: `remuneraciones/${pathLanguageCode}/fiscalizador/login`,
  reset_password_path: `remuneraciones/${pathLanguageCode}/seguridad/account/reset_password/`,
  reset_password_confirm_path: `remuneraciones/${pathLanguageCode}/seguridad/account/reset_password_confirm/`,
  unlock_user_account_path: `remuneraciones/${pathLanguageCode}/seguridad/account/send_unlock_email`,
  reset_user_account_path: `remuneraciones/${pathLanguageCode}/seguridad/account/unlock`,
  is_student_path: `remuneraciones/${pathLanguageCode}/es_estudiante`,
};
